import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"height":"90vh"} }
const _hoisted_2 = {
  key: 0,
  class: "mc innerEditAppointmentContent",
  style: {"margin-top":"10px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "fs24 ls1 mc centered fw600" }, "新しい公開ページを作成", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "w100" }
const _hoisted_8 = { class: "w100" }
const _hoisted_9 = { class: "centering" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = { class: "fs18 fw600" }
const _hoisted_14 = { class: "fs12 dgrey" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "mr5 ml10" }, "作成", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = { class: "fs18 fw600" }
const _hoisted_22 = { class: "fs12 dgrey" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "mr5 ml10" }, "作成", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "mr5 ml10" }, "作成（回答によって日程表示）", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "fs14 fw600" }
const _hoisted_33 = { class: "fs12 dgrey" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "fs22 fw600 mt40" }, [
  /*#__PURE__*/_createTextVNode(" 限定公開ページ "),
  /*#__PURE__*/_createElementVNode("span", { class: "fs14 ddgrey" }, "お相手を指定した日程調整")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, [
  /*#__PURE__*/_createTextVNode(" URLを知っている出席者のみが閲覧することができます。先に出席者を決定し、メールが自動的に送信されます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 社内外問わず、絞られた複数人での調整も可能です。 メールの開封や調整ページへの入室など、出席者の行動追跡ができます。 ")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "fs14 fw600" }
const _hoisted_41 = { class: "fs12 dgrey" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = { key: 1 }
const _hoisted_45 = ["src"]
const _hoisted_46 = ["src"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "w100 mb10" }
const _hoisted_55 = { class: "fl" }
const _hoisted_56 = ["src"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_59 = { class: "ofs" }
const _hoisted_60 = { class: "w100" }
const _hoisted_61 = {
  class: "fs18 fw600 w100 pad10 pointer hoverLightGrey",
  style: {"border":"1px solid #efefef","height":"70px"}
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "fl ml10 fs18 fw600 mt13" }, "出席者を選択", -1)
const _hoisted_63 = ["src"]
const _hoisted_64 = {
  key: 1,
  class: "fl fs14 dgrey ml20"
}
const _hoisted_65 = {
  key: 2,
  class: "fl rad4 redBg pad5 fs13 mt2"
}
const _hoisted_66 = { class: "mr5 mb0 fl" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_71 = {
  key: 0,
  class: "w100 pad20"
}
const _hoisted_72 = {
  class: "fl w50 mr20",
  style: {"max-width":"400px"}
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("p", { class: "header_title fs20 ls1 fw600 mb20" }, "出席者", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_75 = {
  class: "fl w50",
  style: {"max-width":"420px"}
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { class: "w100 mb10" }
const _hoisted_80 = { class: "fl" }
const _hoisted_81 = ["src"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_83 = { class: "mt20 w100 pad20" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "fl fw600 w20 mt30" }, "会議名を入力", -1)
const _hoisted_85 = { class: "fl w70" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "fl fw600 w20 mt40" }, "会議時間", -1)
const _hoisted_88 = { class: "fl w70 mt20" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_90 = { class: "w100 mt40" }
const _hoisted_91 = { class: "fl fw600 w20 mt10" }
const _hoisted_92 = ["src"]
const _hoisted_93 = { class: "fl w70" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_95 = { class: "w100 mt40" }
const _hoisted_96 = { class: "fl fw600 w20 mt40" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("span", null, "利用する調整カレンダー", -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_99 = {
  class: /*#__PURE__*/_normalizeClass(`dgrey fl posRe fw600 mr10 mt5`),
  style: {}
}
const _hoisted_100 = { class: "fl mt13 fs14 fw600" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass(`dgrey fl posRe fw600 mr10 mt5 fs16 pad8`)
}, "新規作成", -1)
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = { key: 2 }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_105 = { key: 2 }
const _hoisted_106 = { class: "w100 mb10" }
const _hoisted_107 = { class: "fl" }
const _hoisted_108 = ["src"]
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_110 = { class: "mt20 w100 pad20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_AttendeesTable = _resolveComponent("AttendeesTable")!
  const _component_AddressBookContent = _resolveComponent("AddressBookContent")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_MeetingTimeContent = _resolveComponent("MeetingTimeContent")!
  const _component_LocationSelectContent = _resolveComponent("LocationSelectContent")!
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_AstagLists = _resolveComponent("AstagLists")!
  const _component_SelectAttendeesWithAddressbook = _resolveComponent("SelectAttendeesWithAddressbook")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "ChooseRoomTypeModal",
    "content-class": "rad10 pad15 with_white_bg shadowContent modalWide noscroll ofs",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.step == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publics, (pub, roomindex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(`llgreyBg mr20 mb10 centered rad20 pad20`),
                        style: {"width":"33%","height":"340px"},
                        key: roomindex
                      }, [
                        (pub.typeName != `feedback_form`)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("img", {
                                src: pub.icon,
                                width: "100",
                                height: "100",
                                class: _normalizeClass(`mt20 ${pub.imageClasses}`)
                              }, null, 10, _hoisted_11),
                              _hoisted_12,
                              _createElementVNode("div", {
                                class: _normalizeClass(`pad10 ${[2, 3].includes(pub.line) ? `mt12` : pub.line == 4 ? `mt6` : `mt1`}`),
                                style: {"padding-right":"10px"}
                              }, [
                                _createElementVNode("p", _hoisted_13, _toDisplayString(pub.title), 1),
                                _createElementVNode("p", _hoisted_14, _toDisplayString(pub.content), 1)
                              ], 2),
                              _createElementVNode("div", {
                                class: "w100 rad8 pad10 dblueBg fw600 mt30 pointer",
                                onClick: ($event: any) => (_ctx.createRoom(`public_room`, pub))
                              }, _hoisted_17, 8, _hoisted_15)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createElementVNode("img", {
                                src: pub.icon,
                                width: "100",
                                height: "100",
                                class: _normalizeClass(`mt20 ${pub.imageClasses}`)
                              }, null, 10, _hoisted_19),
                              _hoisted_20,
                              _createElementVNode("div", {
                                class: _normalizeClass(`pad10 ${[2, 3].includes(pub.line) ? `mt12` : pub.line == 4 ? `mt6` : `mt1`}`),
                                style: {"padding-right":"10px"}
                              }, [
                                _createElementVNode("p", _hoisted_21, _toDisplayString(pub.title), 1),
                                _createElementVNode("p", _hoisted_22, _toDisplayString(pub.content), 1)
                              ], 2),
                              _createElementVNode("div", {
                                class: "w100 rad8 pad10 dblueBg fw600 mt15 pointer",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickFeedbackForm && _ctx.clickFeedbackForm(...args)))
                              }, _hoisted_24),
                              _createElementVNode("div", {
                                class: "w100 rad8 pad10 skyblueBg fw600 mt5 pointer",
                                onClick: ($event: any) => (_ctx.createRoom(`public_room`, pub))
                              }, [
                                _hoisted_26,
                                _createVNode(_component_IconHelp, {
                                  width: 18,
                                  tooltipText: `フォーム上の相談を希望する「はい」の場合に、日程調整を開始します。`,
                                  color: `white`,
                                  style: {"margin-top":"-3px","margin-right":"5px"}
                                })
                              ], 8, _hoisted_25),
                              _hoisted_27
                            ]))
                      ]))
                    }), 128))
                  ]),
                  _hoisted_28,
                  (_ctx.showHidePublics)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hidePublics, (pub, roomindex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "fl fs14 llgreyBg pointer mr20 mb10",
                            style: {"width":"300px","height":"100px"},
                            key: roomindex,
                            onClick: ($event: any) => (_ctx.createRoom(`public_room`, pub))
                          }, [
                            _createElementVNode("img", {
                              src: pub.icon,
                              width: "40",
                              height: "40",
                              class: "mt30 ml20 fl"
                            }, null, 8, _hoisted_31),
                            _createElementVNode("div", {
                              class: _normalizeClass(`fl pad10 ${[2, 3].includes(pub.line) ? `mt12` : pub.line == 4 ? `mt6` : `mt1`}`),
                              style: {"width":"240px","padding-right":"20px"}
                            }, [
                              _createElementVNode("p", _hoisted_32, _toDisplayString(pub.title), 1),
                              _createElementVNode("p", _hoisted_33, _toDisplayString(pub.content), 1)
                            ], 2)
                          ], 8, _hoisted_30))
                        }), 128)),
                        _hoisted_34,
                        _hoisted_35,
                        _hoisted_36,
                        _hoisted_37,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getParents, (parent, roomindex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "fl fs14 llgreyBg pointer mr20 mb10",
                            style: {"width":"300px","height":"100px"},
                            key: `${roomindex}${parent.title}`,
                            onClick: ($event: any) => (_ctx.createRoom(`parent_room`, parent))
                          }, [
                            _createElementVNode("img", {
                              src: parent.icon,
                              width: "40",
                              height: "40",
                              class: "mt30 ml20 fl"
                            }, null, 8, _hoisted_39),
                            _createElementVNode("div", {
                              class: _normalizeClass(`fl pad10 ${
                                        [2, 3].includes(parent.line) ? `mt12` : parent.line == 4 ? `mt6` : `mt1`
                                    }`),
                              style: {"width":"240px","padding-right":"20px"}
                            }, [
                              _createElementVNode("p", _hoisted_40, _toDisplayString(parent.title), 1),
                              _createElementVNode("p", _hoisted_41, _toDisplayString(parent.content), 1)
                            ], 2)
                          ], 8, _hoisted_38))
                        }), 128)),
                        _hoisted_42
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_43,
                  false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        (!_ctx.showHidePublics)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "w100 pointer skyblue centered hoverGrey",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleHidePublics && _ctx.toggleHidePublics(...args)))
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/home/chev_down.png`),
                                style: {"margin-top":"-3px"},
                                width: "23",
                                height: "26"
                              }, null, 8, _hoisted_45),
                              _createTextVNode("他の使い方をみる ")
                            ]))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "w100 pointer skyblue centered hoverGrey",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleHidePublics && _ctx.toggleHidePublics(...args)))
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/home/chev_up.png`),
                                style: {"margin-top":"-3px"},
                                width: "23",
                                height: "26"
                              }, null, 8, _hoisted_46),
                              _createTextVNode("折りたたむ ")
                            ])),
                        _hoisted_47
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_48
              ]),
              _hoisted_49,
              _hoisted_50,
              _hoisted_51
            ]))
          : (_ctx.step == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                (_ctx.rcm.room.room_type == `parent_room`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_left.png`),
                            width: "36",
                            height: "36",
                            class: "pointer",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickPreStep && _ctx.clickPreStep(...args)))
                          }, null, 8, _hoisted_56)
                        ]),
                        (_ctx.enabledSave)
                          ? (_openBlock(), _createElementBlock("section", {
                              key: 0,
                              class: "fr pointer centered circle_button pinkBg fs14 rad8 fw600",
                              style: {"width":"140px","height":"44px","padding":"11px 8px"},
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickNextStep && _ctx.clickNextStep(...args)))
                            }, " 次へ "))
                          : _createCommentVNode("", true),
                        _hoisted_57
                      ]),
                      _hoisted_58,
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("div", _hoisted_61, [
                            _hoisted_62,
                            (_ctx.Util.isPresent(_ctx.rcm.members))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "fl ml20 mt10",
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/check_green.png`),
                                  width: "30",
                                  height: "30"
                                }, null, 8, _hoisted_63))
                              : _createCommentVNode("", true),
                            (_ctx.Util.isPresent(_ctx.rcm.members))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rcm.members, (mem, memindex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: memindex,
                                      class: _normalizeClass(_ctx.isSP ? `fs11 posRe` : `fs11 fl mr2 posRe`)
                                    }, [
                                      mem
                                        ? (_openBlock(), _createBlock(_component_UserIcon, {
                                            key: 0,
                                            width: 48,
                                            canEdit: false,
                                            member: mem,
                                            showTooltip: true,
                                            class: "fl mr5 posRe mb5"
                                          }, null, 8, ["member"]))
                                        : _createCommentVNode("", true)
                                    ], 2))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.rcm.members.length >= 3)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                  _createElementVNode("p", _hoisted_66, [
                                    _createTextVNode(" 人数が多いため投票ページでの作成を推奨します。"),
                                    _hoisted_67,
                                    _createElementVNode("span", {
                                      class: "underline",
                                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.createVotedRoomFromAlert && _ctx.createVotedRoomFromAlert(...args)))
                                    }, "投票ページに変更して作成")
                                  ]),
                                  _createVNode(_component_IconHelp, {
                                    class: "fl",
                                    width: 18,
                                    tooltipText: `限定公開で作成する場合、日程が狭まっていくので、日程投票ページの作成をおすすめします。`,
                                    detailUrl: null,
                                    color: `white`,
                                    style: {"margin-top":"-3px","margin-right":"5px"}
                                  }),
                                  _hoisted_68
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_69
                          ]),
                          _hoisted_70,
                          (_ctx.openHeaderAttendees)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                _createElementVNode("div", _hoisted_72, [
                                  _hoisted_73,
                                  _hoisted_74,
                                  _createVNode(_component_AttendeesTable, {
                                    room: _ctx.rcm.room,
                                    members: _ctx.rcm.members || [],
                                    onDeleteMember: _ctx.deleteMember,
                                    onEditAttendee: _ctx.editAttendee
                                  }, null, 8, ["room", "members", "onDeleteMember", "onEditAttendee"])
                                ]),
                                _createElementVNode("div", _hoisted_75, [
                                  _createVNode(_component_AddressBookContent, {
                                    members: _ctx.rcm.members || [],
                                    currentMember: _ctx.currentMember,
                                    editOrNewForm: _ctx.editOrNewForm,
                                    showEditButton: false,
                                    showNewButton: true,
                                    onAddAttendee: _ctx.addAttendee,
                                    onSelectContactListGroup: _ctx.selectContactListGroup,
                                    class: _normalizeClass(`ofs`),
                                    style: `max-height:480px;`
                                  }, null, 8, ["members", "currentMember", "editOrNewForm", "onAddAttendee", "onSelectContactListGroup"])
                                ]),
                                _hoisted_76,
                                _hoisted_77
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : (_ctx.room.room_type == `public_room`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_left.png`),
                              width: "36",
                              height: "36",
                              class: "pointer",
                              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clickPreStep && _ctx.clickPreStep(...args)))
                            }, null, 8, _hoisted_81)
                          ]),
                          _createElementVNode("section", {
                            class: "fr pointer centered circle_button pinkBg fs14 rad8 fw600",
                            style: {"width":"180px","height":"44px","padding":"11px 8px"},
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.selectAttendees && _ctx.selectAttendees(...args)))
                          }, " 出席者を選択 "),
                          _hoisted_82
                        ]),
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", null, [
                            _hoisted_84,
                            _createElementVNode("div", _hoisted_85, [
                              _createVNode(_component_MdTextfieldTag, {
                                fieldStyle: "min-width:280px;",
                                style: {"height":"56px","min-width":"280px"},
                                class: "fl fs16 w80",
                                type: `AstagName`,
                                placeholder: `全体会`,
                                value: _ctx.appo.name,
                                onInputValue: _ctx.inputMeetingName,
                                ref: `AstagInputField`,
                                onEnter: _ctx.enterName,
                                required: ""
                              }, null, 8, ["value", "onInputValue", "onEnter"])
                            ]),
                            _hoisted_86
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_87,
                            _createElementVNode("div", _hoisted_88, [
                              _createVNode(_component_MeetingTimeContent, {
                                appo: _ctx.appo,
                                onUpdateAppo: _ctx.updateFromChild
                              }, null, 8, ["appo", "onUpdateAppo"])
                            ]),
                            _hoisted_89
                          ]),
                          _createElementVNode("div", _hoisted_90, [
                            _createElementVNode("div", _hoisted_91, [
                              _createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/icons/mappin.png`),
                                width: "22",
                                height: "22",
                                class: "fl mr5 mt12 ml10"
                              }, null, 8, _hoisted_92)
                            ]),
                            _createElementVNode("div", _hoisted_93, [
                              _createVNode(_component_LocationSelectContent, {
                                class: "fl mt15",
                                locationName: _ctx.getLocationName,
                                astag: _ctx.astag,
                                onUpdate: _ctx.updateLocation
                              }, null, 8, ["locationName", "astag", "onUpdate"])
                            ]),
                            _hoisted_94
                          ]),
                          _createElementVNode("div", _hoisted_95, [
                            _createElementVNode("div", _hoisted_96, [
                              _hoisted_97,
                              _createVNode(_component_IconHelp, {
                                width: 18,
                                class: "ml10",
                                tooltipText: `過去に利用した提案候補を再利用する場合は、調整カレンダーを指定します。\n新規で日程候補を選ぶ場合は、「新規作成」にします。\n※ 「日程を自動抽出しない」モードに設定した調整カレンダーのみ利用可能です。`,
                                style: {"margin-top":"-3px","margin-right":"5px"}
                              }),
                              _hoisted_98,
                              _createElementVNode("span", {
                                class: "skyblue pointer",
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clickCreateNewAstag && _ctx.clickCreateNewAstag(...args)))
                              }, "新規作成")
                            ]),
                            (_ctx.astag)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "fl w70 mt20 borderGrey padw6 rad10 pointer",
                                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAstag && _ctx.toggleSelectAstag(...args)))
                                }, [
                                  _createElementVNode("div", _hoisted_99, [
                                    _createVNode(_component_CalendarIcon, {
                                      astag: _ctx.astag,
                                      width: 40,
                                      iconWidth: 40,
                                      totalHeight: 40,
                                      canDelete: false,
                                      hideName: true,
                                      hideBorder: true,
                                      classes: `fl mt3`
                                    }, null, 8, ["astag"]),
                                    _createElementVNode("p", _hoisted_100, _toDisplayString(_ctx.truncate(_ctx.astag.name, 18)), 1)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "fl w70 mt20 borderGrey padw6 rad10 pointer",
                                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAstag && _ctx.toggleSelectAstag(...args)))
                                }, _hoisted_102)),
                            (_ctx.openAstags)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                  _createVNode(_component_AstagLists, {
                                    class: "mt10",
                                    canDelete: false,
                                    from: `quick_vote`,
                                    onSelectEnd: _ctx.selectAstag
                                  }, null, 8, ["onSelectEnd"])
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_104
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
        (_ctx.step == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_left.png`),
                    width: "36",
                    height: "36",
                    class: "pointer",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.clickPreStep && _ctx.clickPreStep(...args)))
                  }, null, 8, _hoisted_108)
                ]),
                _createElementVNode("section", {
                  class: "fr pointer centered circle_button pinkBg fs14 rad8 fw600",
                  style: {"width":"180px","height":"44px","padding":"11px 8px"},
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.goVotePage && _ctx.goVotePage(...args)))
                }, " 候補選択画面へ "),
                _hoisted_109
              ]),
              _createElementVNode("div", _hoisted_110, [
                _createVNode(_component_SelectAttendeesWithAddressbook, { viewType: `mail` })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}